import React, { Component } from "react";
import { Fragment } from "react";
import { FaPlusCircle } from "react-icons/fa";
import { Button, Card, CardBody, CardHeader, Col, Row } from "shards-react";
import { ComplaintListItem } from "../ComplaintListItem/ComplaintListItem";
import { connect } from "react-redux";
import { compose } from "redux";
import { format, fromUnixTime } from "date-fns";
const mapState = (state) => ({
  profile: state.firebase.profile,
  loading: state.async.loading,
});

export class ComplaintList extends Component {
  render() {
    const { complaints, history, handleNewComplaint, profile, archive } =
      this.props;

    let sortedList;

    if (archive && complaints) {
      sortedList = complaints
        .slice()
        .sort((a, b) => b.closedBy?.date - a.closedBy?.date)
        .sort((a, b) => b.lastEdited?.date - a.lastEdited?.date);
    } else {
      sortedList = complaints;
    }

    return window.innerWidth >= 480 ? (
      <Fragment>
        <Row className="my-2">
          <Col>
            <Row>
              <Col>
                <h6>Latest Complaints</h6>
              </Col>
              {profile.role === "complainant" ? (
                <Col>
                  <Button
                    onClick={handleNewComplaint}
                    className="float-right my-2"
                  >
                    <FaPlusCircle className="mr-2" />
                    <span>Add</span>
                  </Button>
                </Col>
              ) : (
                ""
              )}
            </Row>

            <Card small className="mb-4">
              <CardBody className="p-0 pb-3">
                <table className="table mb-0">
                  <thead className="bg-light">
                    <tr>
                      <th scope="col" className="border-0">
                        {" "}
                        {archive ? "Closed Date" : "Date"}
                      </th>
                      <th scope="col" className="border-0 ticketId">
                        Ticket Id
                      </th>
                      <th scope="col" className="border-0">
                        Company
                      </th>

                      {profile && profile.role === "complainant" ? (
                        <th scope="col" className="border-0">
                          Agent
                        </th>
                      ) : (
                        <Fragment>
                          <th scope="col" className="border-0">
                            Complainant
                          </th>
                          <th scope="col" className="border-0">
                            Email
                          </th>
                        </Fragment>
                      )}
                      {profile && profile.role === "manager" ? (
                        <th scope="col" className="border-0">
                          Agent
                        </th>
                      ) : null}

                      <th scope="col" className="border-0">
                        Sector
                      </th>
                      <th scope="col" className="border-0">
                        Category
                      </th>
                      <th scope="col" className="border-0">
                        Complaint Type
                      </th>
                      <th scope="col " className="border-0 text-center">
                        Status
                      </th>
                      <th scope="col " className="border-0 text-center">
                        Details
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedList &&
                      sortedList.map((complaint) => (
                        <tr key={complaint.id}>
                          <ComplaintListItem
                            archive={archive}
                            key={complaint.id}
                            history={history}
                            complaint={complaint}
                            profile={profile}
                          />
                        </tr>
                      ))}
                  </tbody>
                </table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Fragment>
    ) : (
      <Fragment>
        <Row className="my-2 mx-2">
          {complaints &&
            complaints.map((complaint) => (
              <Card className="my-2" size="">
                <CardHeader className="bg-primary text-white">
                  Ticket Id: {complaint.id}
                </CardHeader>
                <CardBody>
                  <div
                    className={
                      "pill mb-2 text-capitalize " +
                      `ticket-` +
                      complaint.status
                    }
                  >
                    {complaint.status}
                  </div>
                  <div>
                    <strong>Company : </strong> {complaint.companyName}
                  </div>
                  <div>
                    <strong>Date : </strong>
                    {complaint.created && complaint.created._seconds
                      ? fromUnixTime(complaint.created._seconds)
                      : format(complaint.created, "dd MMM yyyy")}
                  </div>
                  <div>
                    <strong>Complainant : </strong>
                    {complaint.complainant && complaint.complainant.name}
                  </div>
                  <div>
                    <strong>Complainant Email: </strong>
                    {complaint.complainant && complaint.complainant.email}
                  </div>
                  <div>
                    <strong>Agent : </strong>
                    {complaint.agent && complaint.agent.displayName}
                  </div>
                  <div className="text-center">
                    <Button
                      outline
                      onClick={() => {
                        history.push(
                          `/dashboard/complaintDetails/${complaint.id}`
                        );
                      }}
                    >
                      Details
                    </Button>
                  </div>
                </CardBody>
              </Card>
            ))}
        </Row>
      </Fragment>
    );
  }
}

export default compose(connect(mapState))(ComplaintList);
